<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Banks"
      text="Update payroll bank"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.shift_code"
                v-validate="'required'"
                :error-messages="errors.collect('shift_code')"
                data-vv-name="shift_code"                
                data-vv-as="swift code"                
                label="Swift Code"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.bank_code"
                label="Bank Code"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"          
          class="white--text mb-0"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollBank: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localPayrollBank: null,
        loading: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true
        this.localPayrollBank = { ...this.payrollBank }
        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollBanks().update(this.payrollBank.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        let data = { 
          name: this.localPayrollBank.name,
          shift_code: this.localPayrollBank.shift_code,
          bank_code: this.localPayrollBank.bank_code,
        }
        return data
      },
    },
  }
</script>
